import React, { useRef } from 'react';

import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { RecursiveMenu } from '@uncinc/react-drupal-core';
import { Button, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_TABLET } from '../../config/constants';
import useCurrentUser from '../../hooks/useCurrentUser';
import useLoggedInStatus from '../../hooks/useLoggedInstatus';
import onAccountNavMenuClick from '../../containers/User/helpers';
import { ROUTE_ACCOUNT_EDIT, ROUTE_ACCOUNT_LOGIN } from '../../config/routes';

import './style.scss';

const AccountButton: React.FC = () => {
  const accountNavWrapperRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const user = useCurrentUser();
  const dispatch = useDispatch<any>();
  const { isLoggedIn } = useLoggedInStatus();
  const { width } = useWindowDimensions();

  const { profile } = user ?? {};
  const {
    field_first_name: fieldFirstName = null,
    field_last_name: fieldLastName = null,
    field_infix_name: fieldInfixName = null,
  } = profile ?? {};

  const accountNavVisible = useRef(false);

  const toggleClasses = () => {
    accountNavWrapperRef?.current?.classList.toggle('menuIsOpen');
    accountNavVisible.current = !accountNavVisible.current;
  };

  const handleAccountButtonClick = () => {
    if (isLoggedIn === null) return;
    if (isLoggedIn !== false) toggleClasses();
    else history.push(ROUTE_ACCOUNT_LOGIN);
  };

  const onRecursiveMenuClick = (
    e: React.MouseEvent<React.HTMLAttributes<HTMLDivElement>, MouseEvent>,
  ) => {
    onAccountNavMenuClick(history, dispatch, e);
  };

  return (
    <div
      className="AccountNav"
      ref={accountNavWrapperRef}
      onBlur={() => {
        if (width > SCREEN_TABLET && accountNavVisible.current) setTimeout(toggleClasses, 120);
      }}
    >
      <div className="AccountButton">
        <Button
          primary={false}
          onClick={handleAccountButtonClick}
          className="AccountButton__desktop"
        >
          {
            fieldFirstName ? (
              <span className="AccountButton__initials">
                {fieldFirstName[0]!.value[0]}{fieldLastName && fieldLastName[0]
                  ? fieldLastName[0].value[0] : ''}
              </span>
            )
              : <i className="icon icon-user" />
          }
        </Button>
        <Button
          primary={false}
          className="AccountButton__mobile"
          href={user ? ROUTE_ACCOUNT_EDIT : ROUTE_ACCOUNT_LOGIN}
        >
          {
            fieldFirstName ? (
              <span className="AccountButton__initials">
                {fieldFirstName[0]!.value[0]}{fieldLastName && fieldLastName[0]
                  ? fieldLastName[0].value[0] : ''}
              </span>
            )
              : <i className="icon icon-user" />
          }
        </Button>
        <div
          className="AccountButton__nav"
          aria-expanded={accountNavVisible.current}
        >
          {
            fieldFirstName && (
              <div className="AccountButton__nav__name">
                <span>
                  {fieldFirstName[0]!.value}
                  {fieldInfixName && fieldInfixName[0] ? ` ${fieldInfixName[0].value}` : ''}
                  {fieldLastName && fieldLastName[0] ? ` ${fieldLastName[0].value}` : ''}
                </span>
              </div>
            )
          }
          <RecursiveMenu
            menuId="account"
            onClick={onRecursiveMenuClick}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(AccountButton);
